import { render, staticRenderFns } from "./FullScreenLoading.vue?vue&type=template&id=bfa5449e&scoped=true"
import script from "./FullScreenLoading.vue?vue&type=script&lang=js"
export * from "./FullScreenLoading.vue?vue&type=script&lang=js"
import style0 from "./FullScreenLoading.vue?vue&type=style&index=0&id=bfa5449e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa5449e",
  null
  
)

export default component.exports